import script from "./GiftSection.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftSection.vue?vue&type=script&setup=true&lang=js"

import "./GiftSection.vue?vue&type=style&index=0&id=2bfbc39d&lang=css"

const __exports__ = script;

export default __exports__